// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"212":"771ce654","319":"ce159f95","479":"a37a8462","561":"565ef2ef","777":"43920c4d","985":"09623dd2"}[chunkId] + ".chunk.css";
};